// src/routes/RedirectOnInvalidRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../utils/auth";

const RedirectOnInvalidRoute = () => {
  return isAuthenticated() ? (
    <Navigate to="/" replace />
  ) : (
    <Navigate to="/login" replace />
  );
};

export default RedirectOnInvalidRoute;
